import { Directive, HostListener } from '@angular/core';

import { CursorService } from './cursor.service';

@Directive({
    selector: '[luiCursorOnHover]',
    standalone: false
})
export class CursorOnHoverDirective {
  @HostListener('mouseenter') onMouseEnter(): void {
    this.show();
  }

  @HostListener('mouseleave') onMouseLeave(): void {
    this.close();
  }

  constructor(private cursorService: CursorService) {}

  show() {
    this.cursorService.create();
  }

  close(): void {
    this.cursorService.close();
  }
}
